<div
  class="formborder row m-0 mt-1 p-1 align-items-center justify-content-between"
>
  <div class="col-md-5">
    <h6 class="m-0">Sanction Conditions</h6>
  </div>

  <div class="">
    <button
      type="button"
      class="btn font-size-12 button-btn"
      (click)="addSanctionConditions()"
      *ngIf="PageAcess && PageAcess[0].Add == 1 && !loanSummary.IsQLSFile"
    >
      Add Sanction Conditions
    </button>
  </div>
</div>

<table class="table table-bordered mt-2" id="Sanction">
  <thead>
    <tr>
      <th>Header</th>
      <th class="WD-66">Details</th>
      <th class="WD-16">Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let vdData of Headers; let i = index">
      <td>{{ vdData.Header }}</td>
      <td>
        <table>
          <tr *ngFor="let data of vdData.Condition; let i = index">
            <td>{{ data.Detail }}</td>
          </tr>
        </table>
      </td>
      <td style="vertical-align: middle; white-space: nowrap">
        <button
          type="button"
          id="Edit"
          (click)="OnEditSanctionConditions(vdData)"
          class="btn font-size-12 button-btn"
          mat-raised-button
          [class.spinner]="loading"
          style="padding: 2px 0.625rem; line-height: 1.375rem; min-width: 3.75rem"
          *ngIf="PageAcess && PageAcess[0].Edit == 1 && !loanSummary.IsQLSFile"
        >
          Edit
        </button>
        <button
          type="button"
          id="Delete"
          (click)="OnDeleteSanctionConditions(vdData.Id)"
          class="btn font-size-12 button-btn ml-1"
          mat-raised-button
          [class.spinner]="loading"
          style="padding: 2px 0.625rem; line-height: 1.375rem; min-width: 3.75rem"
          *ngIf="PageAcess && PageAcess[0].Delete == 1 && !loanSummary.IsQLSFile"
        >
          Delete
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div
  class="modal fade in"
  id="SanctionConditions"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{ Value }} Sanction Conditions
        </h6>
        <button
          type="button"
          (click)="onCloseSanctionConditions()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-body">
          <form #f="ngForm" novalidate class="formborder">
            <div class="row m-0 mt-1">
              <div class="col-md-12">
                <span class="required-lable"> Header </span>
                <input
                  type="text"
                  #refHeader="ngModel"
                  required
                  [(ngModel)]="Header"
                  placeholder="Header"
                  name="Header"
                  id="Header"
                  class="form-control input-text-css"
                  [ngClass]="{
                    'is-invalid': f.submitted && refHeader.invalid,
                    'alert-warning':
                      refHeader.invalid &&
                      (refHeader.dirty ||
                        refHeader.touched ||
                        refHeader.untouched)
                  }"
                />
              </div>
            </div>
            <form #df="ngForm" novalidate>
              <div
                class="row m-0 add-remove"
                *ngFor="let vdData of SanctionConditionsDetails; let i = index"
                style="margin-top: 0.5rem !important"
              >
                <div class="col-md-12 row m-0 type-column">
                  <div
                    [ngClass]="{ 'bg-success1': i == 0 }"
                    *ngIf="i == 0"
                    style="width: 100%"
                  >
                    Conditions
                  </div>
                  <input
                    type="text"
                    name="Conditions{{ i }}"
                    id="Conditions{{ i }}"
                    class="form-control input-text-css"
                    #refConditions="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid': df.submitted && refConditions.invalid,
                      'alert-warning':
                        refConditions.invalid &&
                        (refConditions.dirty ||
                          refConditions.touched ||
                          refConditions.untouched),
                      'mt-1': i == 0
                    }"
                    [(ngModel)]="vdData.Detail"
                  />
                </div>
                <button
                  type="button"
                  class="remove"
                  (click)="removeData(i)"
                  [ngClass]="{ 'no-head': i != 0 }"
                  *ngIf="SanctionConditionsDetails.length > 1"
                >
                  -
                </button>
                <button
                  type="button"
                  class="addmore"
                  (click)="addMoreData(i)"
                  [ngClass]="{
                    both: SanctionConditionsDetails.length > 1,
                    'no-head': i != 0
                  }"
                  [disabled]="!df.form.valid"
                  *ngIf="i == SanctionConditionsDetails.length - 1"
                >
                  +
                </button>
              </div>
              <div class="row col-md-12 m-0 mt-3 justify-content-end">
                <button
                  type="button"
                  (click)="onCloseSanctionConditions()"
                  class="btn font-size-12 button-btn"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  id="btnSanctionConditions"
                  #btnRegisterNewCustomer
                  (click)="OnSaveSanctionConditions()"
                  class="ml-4 btn font-size-12 button-btn"
                  [class.spinner]="loading"
                  [disabled]="!f.form.valid && !df.form.valid"
                >
                  {{ BtnValue }}
                </button>
              </div>
            </form>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="display: flex; align-items: center; gap: 0.9375rem">
<div>
  <button *ngIf="VKYCData && VKYCData.length > 0 && !hasVkycResult"
          type="button" id="SignzyVideoKYCGetdata" style="background-color: green" (click)="GetData_VKYC_Signzy()"
          class="btn font-size-12 button-btn mt-2">
        Get VKYC Data
        </button>

        <button *ngIf="videoUrl && !hasVkycResult"
          type="button" id="SignzyVideoKYCOpenLink" style="background-color: green" (click)="OpenLink()"
          class="btn font-size-12 button-btn mt-2">
        Open link
        </button>
        <button *ngIf="videoUrl && !hasVkycResult"
        type="button" id="SignzyVideoKYCCopyLink" style="background-color: #007bff" (click)="CopyLink()"
        class="btn font-size-12 button-btn mt-2">
          {{ copied ? 'Copied!' : 'Copy link' }}
        </button>
        
         <button *ngIf="ShowKYCData"
          type="button" id="ViewVerifiedVKYC" style="background-color: green" (click)="ViewVKYCData()"
          class="btn font-size-12 button-btn mt-2">
        View Verified VKYC
        </button>
</div>
</div>

<!-- Show heading only when E-Sign data exists -->
<h6 class="mt-2 mb-2" *ngIf="dataSourceEsign && dataSourceEsign.data?.length">
  E-Sign Details
</h6>
 <!-- Show table only when E-Sign data exists -->
 <div class="table-responsive" *ngIf="dataSourceEsign && dataSourceEsign.data?.length">
      <mat-table [dataSource]="dataSourceEsign" matSort style="height: 60vh; overflow: auto">
        <ng-container matColumnDef="Id">
          <mat-header-cell mat-sort-header class="grid-header" style="max-width: 2.5rem" *matHeaderCellDef>
            #
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 2.5rem; max-height: 0.3125rem">
            <!-- Row serial with paginator-safe fallback -->
            {{ (paginatorRef?.pageIndex || 0) * (paginatorRef?.pageSize || 20) + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
            Status
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Status }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Type">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
            Type
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="UploadId">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
            UploadId
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.UploadId }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Action">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
            Action
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
            <!-- <i aria-label="true"
           class="fa fa-trash style-delete"
           (click)="checkStatusForEsignAgreement(row)"
           *ngIf="row.Status == 'requested'"></i> -->
            <button *ngIf="row.Status == 'requested'" type="button" style="background-color: #a7a72b; color: black"
              (click)="checkStatusForEsignAgreement(row)" class="ml-3 btn font-size-12 button-btn mt-2">
              Check E-Sign Status
            </button>
            <button *ngIf="row.Status == 'completed' || row.Status == 'Completed'" type="button" style="background-color: green"
              (click)="downloadESignAgreement(row)" class="ml-3 btn font-size-12 button-btn mt-2">
              Download E-Sign
            </button>
          </mat-cell>
        </ng-container>
        <!-- Header and Row Declarations -->
        <mat-header-row *matHeaderRowDef="displayedColumnsEsign; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsEsign"></mat-row>
      </mat-table>

      <div class="row m-0 align-items-center">
        <div class="col-md-12">
          <!-- E-Sign table paginator -->
          <mat-paginator #paginatorRef [pageSize]="20" [pageSizeOptions]="[20, 50]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
<div class="col-md-12" style="display: flex; justify-content: flex-end; align-items: center; gap: 0.625rem;">
  <app-loan-application-form style="display: inline-flex; align-items: center;" [loanId]="loanSummary.LoanId">
    <button class="btn btn font-size-12 button-btn mt-2">
      <i class="fas fa-file-alt"></i> Loan Application
    </button>
  </app-loan-application-form>
  <button
    type="button"
    (click)="onNext()"
    class="mt-2 btn font-size-12 button-btn"
    [class.spinner]="loading"
  >
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div>

<div class="modal fade in" id="signzyVKYCModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Video KYC Result
        </h6>
        <button type="button" (click)="onCloseSignzyVKYCModal()" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body" *ngIf="vkycResult as result">
        <div class="row m-0">

          <!-- Captured Image -->
          <!-- <div class="col-md-6 mb-3">
            <label class="required-lable">Captured Image</label>
            <div class="border rounded p-2 text-center">
              <img [src]="result.capturedImage" alt="Captured Image"
                style="max-width: 100%; max-height: 260px; object-fit: contain;" />
            </div>
          </div> -->

          <!-- Video -->
          <!-- <div class="col-md-6 mb-3">
            <label class="required-lable">Recorded Video</label>
            <div class="border rounded p-2 text-center">
              <video [src]="result.video" controls style="max-width: 100%; max-height: 260px;"></video>
            </div>
          </div> -->

          <!-- Detail fields -->
           <!-- Captured Image -->
<div class="col-md-6 mb-3">
  <label class="required-lable">Captured Image</label>
  <div class="border rounded p-2 text-center">
    <img [src]="result.capturedImage" alt="Captured Image"
      style="max-width: 100%; max-height: 260px; object-fit: contain;" />
    <div class="mt-2">
      <button type="button" class="btn font-size-12 button-btn"
        (click)="downloadFile(result.capturedImage, 'vkyc_image_' + result.consumerId + '.jpg')">
        <i class="fas fa-download"></i> Download Image
      </button>
    </div>
  </div>
</div>

<!-- Video -->
<div class="col-md-6 mb-3">
  <label class="required-lable">Recorded Video</label>
  <div class="border rounded p-2 text-center">
    <video [src]="result.video" controls style="max-width: 100%; max-height: 260px;"></video>
    <div class="mt-2">
      <button type="button" class="btn font-size-12 button-btn"
        (click)="downloadFile(result.video, 'vkyc_video_' + result.consumerId + '.webm')">
        <i class="fas fa-download"></i> Download Video
      </button>
    </div>
  </div>
</div>

          <div class="col-md-4 mb-2">
            <label>Used</label>
            <input type="text" class="form-control input-text-css"
              [value]="result.isUsed === 1 ? 'Yes' : 'No'" readonly />
          </div>

          <div class="col-md-4 mb-2">
            <label>Liveness</label>
            <input type="text" class="form-control input-text-css"
              [value]="result.passiveLiveliness?.liveness ? 'Passed' : 'Failed'" readonly />
          </div>

          <div class="col-md-4 mb-2">
            <label>Liveness Score</label>
            <input type="text" class="form-control input-text-css" [value]="result.passiveLiveliness?.score" readonly />
          </div>

          <div class="col-md-4 mb-2">
            <label>Audio Text Match Score</label>
            <input type="text" class="form-control input-text-css"
              [value]="result.audioTextMatch?.matchAudioScore" readonly />
          </div>

          <div class="col-md-4 mb-2">
            <label>IP Address</label>
            <input type="text" class="form-control input-text-css" [value]="result.ipAddress" readonly />
          </div>
          <div class="col-md-4 mb-2">
  <label>Latitude</label>
  <input type="text" class="form-control input-text-css" [value]="result.geoLocation?.latitude" readonly />
</div>

<div class="col-md-4 mb-2">
  <label>Longitude</label>
  <input type="text" class="form-control input-text-css" [value]="result.geoLocation?.longitude" readonly />
</div>

<div class="col-md-4 mb-2" *ngIf="result.geoLocation?.latitude && result.geoLocation?.longitude">
  <label>Location</label>
  <div>
    <a class="btn font-size-12 button-btn"
      [href]="'https://www.google.com/maps?q=' + result.geoLocation.latitude + ',' + result.geoLocation.longitude"
      target="_blank" rel="noopener noreferrer">
      <i class="fas fa-map-marker-alt"></i> View on Map
    </a>
  </div>
</div>

          <div class="col-md-4 mb-2">
            <label>Date</label>
            <input type="text" class="form-control input-text-css" [value]="result.date" readonly />
          </div>

          <div class="col-md-4 mb-2">
            <label>Time</label>
            <input type="text" class="form-control input-text-css" [value]="result.timestamp" readonly />
          </div>

        </div>

        <div class="row col-md-12 m-0 mt-3 justify-content-end">
          <button type="button" (click)="onCloseSignzyVKYCModal()" class="btn font-size-12 button-btn"
            data-dismiss="modal">
            Close
          </button>
        </div>
      </div>

      <div class="modal-body" *ngIf="!vkycResult">
        <p class="text-center text-muted">No VKYC data available.</p>
      </div>

    </div>
  </div>
</div>